import { render } from "./WNrestartRecordList.vue?vue&type=template&id=70fc692d&scoped=true"
import script from "./WNrestartRecordList.vue?vue&type=script&lang=js"
export * from "./WNrestartRecordList.vue?vue&type=script&lang=js"

import "./WNrestartRecordList.vue?vue&type=style&index=0&id=70fc692d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70fc692d"

export default script